module.exports = __webpack_public_path__ + "static/img/Einlage.6c3f6bbb.svg";